import { ONE, ZERO } from '@/constants';

const EXPIRED_COOKIE_DATE = 'Thu, 01 Jan 1970 00:00:00 GMT';

const getCookieDomains = () => {
  const hostname = window.location.hostname.trim().toLowerCase();

  if (!hostname || hostname === 'localhost') {
    return [];
  }

  const parts = hostname.split('.').filter(Boolean);

  if (parts.length < 2) {
    return [];
  }

  const domains = new Set<string>();

  for (let index = ZERO; index < parts.length - ONE; index += ONE) {
    const domain = parts.slice(index).join('.');

    domains.add(domain);

    if (index > ZERO) {
      domains.add(`.${domain}`);
    }
  }

  return [...domains];
};

export const clearCookies = () => {
  const cookies = document.cookie;
  const domains = getCookieDomains();

  cookies.split(';').forEach((cookie) => {
    const position = cookie.indexOf('=');
    const updated = (
      position > -ONE ? cookie.substring(ZERO, position) : cookie
    ).trim();

    if (!updated) {
      return;
    }

    document.cookie = `${updated}=;expires=${EXPIRED_COOKIE_DATE}`;
    document.cookie = `${updated}=;expires=${EXPIRED_COOKIE_DATE};path=/`;

    domains.forEach((domain) => {
      document.cookie = `${updated}=;expires=${EXPIRED_COOKIE_DATE};domain=${domain}`;
      document.cookie = `${updated}=;expires=${EXPIRED_COOKIE_DATE};path=/;domain=${domain}`;
    });
  });
};

export const setCookie = (
  name: string,
  value: string,
  expiration: Date | null,
) => {
  let cookieString = `${name}=${value};path=/`;
  if (expiration) {
    cookieString = `${cookieString};expires=${expiration.toUTCString()}`;
  }
  document.cookie = cookieString;
};

export const clearCache = () => {
  try {
    localStorage.clear();
  } catch {
    // ignore
  }

  try {
    sessionStorage.clear();
  } catch {
    // ignore
  }

  try {
    clearCookies();
  } catch {
    // ignore
  }
};
